import {
    FieldInCard,
} from 'app/types/form.types'
import {
    LoggerExchangeReason, LoggerType,
} from 'app/enums/label.enums'

import {
    ContainerStatusChangeNote,
} from '../../../ContainerNotes.types'

import {
    AuditTrailConfig, StatusChangeConfig, getChangeConfig,
} from './notesConfigs'

type Fields = keyof ContainerStatusChangeNote

const getContainerStatusFields = ({
    isNewStatusLoggerToBeExchanged, getAllowedValues,
}: {
    isNewStatusLoggerToBeExchanged: boolean,
    getAllowedValues: (param: Record<string, any>) => Record<string, string>
})
    : FieldInCard<Fields>[] => {
    return [
        getChangeConfig({
            showOrder: true,
        }),
        isNewStatusLoggerToBeExchanged
            ? {
                ...StatusChangeConfig,
                fields: [
                    ...StatusChangeConfig.fields,
                    {
                        name: 'loggerExchangeReason',
                        labelKey: 'LOGGER_EXCHANGE_REASON',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(LoggerExchangeReason),
                        disabled: true,
                    },
                    {
                        name: 'requiredLoggerExchange',
                        labelKey: 'REQUIRED_LOGGER_EXCHANGE',
                        componentName: 'MultiEnumSelector',
                        allowedValues: getAllowedValues(LoggerType),
                        disabled: true,
                    },
                ],
            } : StatusChangeConfig,
        {
            title: 'LOCATION',
            className: 'location',
            fields: [{
                name: 'location',
                componentName: 'LocationObjectSelector',
                labelKey: 'LOCATION',
            }],
        },
        AuditTrailConfig,
    ]
}

export default getContainerStatusFields
